import React, { useState, useContext } from 'react';

import './styles.css';

import { InputText } from '../InputText';
import { LabelForm } from '../LabelForm';
import { Button } from '../Button';
import { GlobalContext } from '../../contexts/HomeContext';
import { ReenviarSenha } from '../../utils/api/api';
import { toast } from 'react-toastify';
import P from 'prop-types';
import { Modal } from '../Modal';
import { Tabs } from '../Tabs';

export const RecuperarSenha = ({ handleModal }) => {
  const { dadosApp } = useContext(GlobalContext);
  const [dados, setDados] = useState({});
  const [modalLoading, setModalLoading] = useState('none');
  const [tabEntregaActive, setTabEntregaActive] = useState(0);

  const showHideModalLoading = () => {
    setModalLoading(modalLoading == 'none' ? 'block' : 'none');
  };

  function ValidateEmail() {
    if (typeof dados['email'] !== 'undefined') {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
      );

      if (!pattern.test(dados['email'])) {
        return false;
      }
      return true;
    }
  }

  const handleInputs = (event) => {
    let target = event.target;
    let value = target.type == 'checkbox' ? target.checked : target.value;
    dados[target.name] = value;
    if (target.name == 'telefone') {
      if (value.length == 9) {
        dados['telefone'] = String(value).replace(/(\d{2})?(\d{4})?(\d{3})/, '($1)$2-$3'); // eslint-disable-line
      }
    }
    setDados({ ...dados });
  };

  const obterDadosEnvio = () => {
    let data = {
      telefone_ddd: '',
      telefone: '',
      email: '',
      idloja: dadosApp.IdLoja,
    };

    if (tabEntregaActive === 0) {
      let tel = dados.telefone.replace('(', '').replace(')', '').replace('-', '');
      data.telefone_ddd = tel.substring(0, 2);
      data.telefone = tel.substring(2);
    } else {
      data.email = dados.email;
    }
    return data;
  };

  const validarDados = () => {
    if (tabEntregaActive === 0) {
      if (dados.telefone) {
        let tel = dados.telefone.replace('(', '').replace(')', '').replace('-', '');
        if (tel?.length < 10 || tel?.length > 11 || isNaN(tel) || tel == '') {
          toast.error('Telefone inválido', { containerId: 'modalToast' });
          return false;
        }
      } else {
        toast.error('Telefone inválido', { containerId: 'modalToast' });
        return false;
      }
    } else {
      const isValid = ValidateEmail(dados['email']);
      if (!isValid) {
        toast.error('Email inválido');
        return false;
      }
    }
    return true;
  };

  const handleRecuperarSenha = async () => {
    if (validarDados()) {
      showHideModalLoading();
      const response = await ReenviarSenha(obterDadosEnvio());
      setModalLoading('none');
      if (response.data.Retorno) {
        if (response.data.Retorno.status == 1) {
          toast.error('Erro ao enviar senha: ' + response.data.Retorno.msg, { containerId: 'modalToast' });
          return;
        }
      }

      if (response.data) {
        toast.success('Senha reenviada com sucesso!', { containerId: 'modalToast' });
        handleModal('LOGIN', 'Login');
      } else {
        toast.error(tabEntregaActive === 0 ? 'Telefone não cadastrado!' : 'Email não cadastrado!', {
          containerId: 'modalToast',
        });
      }
    }
  };

  return (
    <>
      <div style={{ width: 'calc(100%)' }}>
        <Tabs text1={'Telefone'} text2={'Email'} active={tabEntregaActive} setTabActive={setTabEntregaActive} />
      </div>
      <div className={'modal-content-dialog'} style={{ paddingBottom: '25px', borderTop: 0 }}>
        <div className="recuperacao-texto">
          {/* <p className="center">Não se preocupe, vamos enviar novamente sua senha para o seu telefone ou email.</p> */}
          <p className="center">Informe o seu Telefone ou Email para reenviarmos seus dados de login.</p>
        </div>

        <form>
          <div className="form-group center">
            <LabelForm
              text={tabEntregaActive === 0 ? 'Telefone Celular com DDD' : 'Email'}
              labelFor={tabEntregaActive === 0 ? 'telefone' : 'email'}
              style={{ TextAlign: 'center' }}
            />
            <InputText
              type={'text'}
              placeHolder={''}
              className={'form-control'}
              name={tabEntregaActive === 0 ? 'telefone' : 'email'}
              value={tabEntregaActive === 0 ? dados.telefone : dados.email}
              onChange={handleInputs}
            />
            <i className="material-icons">{tabEntregaActive === 0 ? 'local_phone' : 'mail_outline'}</i>
          </div>
          <div className={'clearfix-checkbox'}></div>
        </form>
        <Button text="Enviar" className={'btn_1 btnGradient btn-width-full'} onClick={handleRecuperarSenha} />
      </div>

      {modalLoading == 'block' && (
        <Modal
          title=""
          isFooter={false}
          visibility={modalLoading}
          param={{ msg: 'Aguarde' }}
          page="LOADING"
          customPosition="loading-modal"
        />
      )}
    </>
  );
};

RecuperarSenha.propTypes = {
  handleModal: P.func,
};
